export default {
    replaceProject(state, payload) {
        state.project = payload;
    },
    patchProject(state, payload) {
        state.project = { ...state.project, ...payload };
    },
}